import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import { spinner } from '../assets';

const ContactPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState(false);
  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await emailjs.send(
        process.env.REACT_APP_EMAIL_SERVICE_ID,
        process.env.REACT_APP_EMAIL_TEMPLATE_ID,
        formValues,
        process.env.REACT_APP_EMAIL_PUBLIC_KEY,
      );
      setFormValues({ name: '', email: '', message: '' });
      setNotification(true);
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="bg-white dark:bg-black2 transition">
      <div className="wrapper pb-[100px] pt-[120px]">
        <div className="section-title contact-title dark:before:bg-primaryOrange/25">
          <h2 className="relative text-primaryBlack dark:text-white text-[36px] md:text-[67px] leading-[50px] md:leading-[86px] font-extrabold md:font-bold">
            Contact Me
          </h2>
        </div>

        {notification && (
          <h3 className="text-center text-base text-primaryBlue font-semibold pt-10">
            Thank you for reaching out! I will do my best to respond to your
            message as soon as possible.
          </h3>
        )}

        <div className="pt-20 max-w-[750px] mx-auto">
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col mb-[48px]">
              <label
                htmlFor="name"
                className="font-medium text-[16px] text-primaryBlue pb-[4px]"
              >
                Full Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="enter your name"
                required
                value={formValues.name}
                onChange={handleChange}
                autoComplete="off"
                className="text-primaryGray py-[4px] border-0 border-b border-primaryGray outline-none
            focus:border-primaryBlue placeholder:font-normal dark:bg-black2"
              />
            </div>
            <div className="flex flex-col mb-[48px]">
              <label
                htmlFor="email"
                className="font-medium text-[16px] text-primaryBlue pb-[4px]"
              >
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="enter your email"
                required
                value={formValues.email}
                onChange={handleChange}
                autoComplete="off"
                className="text-primaryGray py-[4px] border-0 border-b border-primaryGray outline-none
            focus:border-primaryBlue placeholder:font-normal dark:bg-black2"
              />
            </div>
            <div className="flex flex-col mb-[48px]">
              <label
                htmlFor="Message"
                className="font-medium text-[16px] text-primaryBlue pb-[4px]"
              >
                Message
              </label>
              <textarea
                name="message"
                placeholder="enter your message"
                required
                value={formValues.message}
                onChange={handleChange}
                className="text-primaryGray py-[4px] border-0 border-b border-primaryGray outline-none
            focus:border-primaryBlue placeholder:font-normal h-[135px] dark:bg-black2"
              />
            </div>
            <div className="flex flex-row gap-6 items-start md:items-center">
              <button type="submit" className="button" disabled={isLoading}>
                Send Message
              </button>
              {isLoading && (
                <img alt="spinner" src={spinner} className="w-[60px]" />
              )}
              <Link
                to="/"
                download
                target="_blank"
                className="resume !hidden mt-5 md:mt-0 dark:before:border-[#13131a_rgba(255,255,255,0.3)_rgba(255,255,255,0.3)_#13131a]"
              >
                Resume
              </Link>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
